import { INSULATION_ANSWER_LABELS } from '@alpinehomeair/common';
import FormInput from 'components/common/form-input';
import { ComfortSettingsFieldsProps } from 'components/structure-page/comfort-settings-fields-types';

// The answers the estimate can take; the request builder maps the same list.
const insulationOptions = [...INSULATION_ANSWER_LABELS];

export default function ComfortSettingsFields({
  insulation,
  desiredHeating,
  desiredCooling,
  onInsulationChange,
  onDesiredHeatingChange,
  onDesiredCoolingChange
}: ComfortSettingsFieldsProps) {
  return (
    <>
      <tr>
        <td className='p-2 text-right text-lg font-semibold'>
          How would you rate the home&apos;s insulation?
        </td>
        <td className='py-2'>
          <FormInput
            type='select'
            value={insulation ?? ''}
            options={insulationOptions}
            enableChips
            preventDeselection
            onChange={(value) => onInsulationChange(String(value))}
          />
        </td>
      </tr>
      <tr>
        <td className='p-2 text-right text-lg font-semibold'>
          Summer thermostat setting:
        </td>
        <td className='py-2'>
          <div className='max-w-[80px]'>
            <FormInput
              type='number'
              value={desiredCooling}
              min={65}
              max={85}
              suffix='°F'
              onChange={(value) => onDesiredCoolingChange(Number(value))}
            />
          </div>
        </td>
      </tr>
      <tr>
        <td className='p-2 text-right text-lg font-semibold'>
          Winter thermostat setting:
        </td>
        <td className='py-2'>
          <div className='max-w-[80px]'>
            <FormInput
              type='number'
              value={desiredHeating}
              min={60}
              max={80}
              suffix='°F'
              onChange={(value) => onDesiredHeatingChange(Number(value))}
            />
          </div>
        </td>
      </tr>
    </>
  );
}
